<template>
  <!-- 手动催评-批量发送短信组件 -->
  <div class="sendSms">
    <el-drawer :visible.sync="drawer" direction="rtl" :with-header="false" :modal-append-to-body="false"
      :before-close="handleClose" :size="1400">
      <div class="wrapper">
        <!-- 头部设置 -->
        <header class="head">
          <div class="left">
            <span class="tit">发送短信</span>
          </div>
          <i class="el-icon-close close" @click="handleClose"></i>
        </header>
        <!-- 温馨提示 -->
        <div class="topTis" v-if="isMedialSms">
          <img src="@/assets/images/提示_黄.png" style="
                          display: inline-block;
                          position: absolute;
                          width: 14px;
                          height: 14px;
                          color: #ffffff;
                          left: 15px;
                          top: 15px;
                        " />
          <div class="desc" style="margin-left: 24px">
            <p>温馨提示：</p>
            <p class="setting-text">
              此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~
              <span style="cursor: pointer; margin-left: 10px" @click="setDialogVisible = true">去设置</span>
            </p>
            <p><span style="font-weight: bold;">1.审核规则</span></p>
            <p>
              （1）普通短信：提交<span class="count1">10W</span>条以上短信需人工审核，<span class="count1">审核时间为每工作日18点（建议商家提前一天创建活动）；</span>
            </p>
            <p>
              （2）<span class="count1">富信/卡片短信：使用前需经过运营商审核与条线运营审核模板，预计2-4个工作日，请至少提前2个工作日创建模板，模板审核通过后才可在短信发送任务中选上模板使用；</span>
            </p>
            <p><span style="font-weight: bold;">2.发送时间范围</span>（普通短信/富信/卡片短信）：早9:00-晚20:00（日常）</p>
            <p><span style="font-weight: bold;">3.日常频控规则:</span></p>
            <p>同一店铺 3 天内给同一手机号发送商家营销短信的条数不超过 1条;每个手机号每 1天只能收到 3条商家营销短信,每 2天只能收到 4条商家营销短信<span
                class="count1">（*商家营销短信包括普通短信、富信和卡片短信）</span></p>
          </div>
        </div>
        <div class="topTis" style="background-color: #fafafa;" v-else>
          <img src="@/assets/images/new_icon_waring_red.png" style="
                          display: inline-block;
                          position: absolute;
                          width: 14px;
                          height: 14px;
                          color: #ffffff;
                          left: 15px;
                          top: 15px;
                        " />
          <div class="desc" style="margin-left: 24px">
            <p>温馨提示</p>
            <p>此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~<span style="cursor: pointer; margin-left: 10px"
                @click="setDialogVisible = true">去设置</span></p>
                <p>
            （1）普通短信：提交<span style="color: red;">10W</span>条以上短信需人工审核，<span style="color: red;">审核时间为每工作日18点（建议商家提前一天创建活动）；</span>
          </p>
          <p>
            （2）<span style="color: red;">富信/卡片短信：使用前需经过运营商审核与条线运营审核模板，预计2-4个工作日，请至少提前2个工作日创建模板，模板审核通过后才可在短信发送任务中选上模板使用；</span>
          </p>
          <p><span style="font-weight: bold;">2.发送时间范围</span>（普通短信/富信/卡片短信）：早9:00-晚20:00（日常）</p>
          <p><span style="font-weight: bold;">3.日常频控规则:</span></p>
          <p>同一店铺 3 天内给同一手机号发送商家营销短信的条数不超过 1条;每个手机号每 1天只能收到 3条商家营销短信,每 2天只能收到 4条商家营销短信<span style="color: red;">（*商家营销短信包括普通短信、富信和卡片短信）</span></p>
          </div>
        </div>
        <section class="main">
          <!-- 表单内容 -->
          <el-form ref="formSearch" :model="form" label-width="80px" :style="{ 'margin-bottom': form.smsType == 1 ? '70px' : '' }">
            <el-form-item label="发送对象:">已选择
              <i v-show="preLoading" :style="{ color: globalBG }" class="el-icon-loading"></i>
              <span style="color: #fe4d45" v-show="!preLoading">{{ sendObjectCount }}</span>
              位会员</el-form-item>

            <el-form-item label="活动主题:">
              <el-input max v-model="form.title"> </el-input>
            </el-form-item>
            <el-form-item label="短信类型:" v-if="isMedialSms">
              <el-radio-group v-model="form.smsType" style="padding-top: 9px;">
                <el-radio :label="0">普通短信</el-radio>
                <el-radio :label="1">富信</el-radio>
                <el-radio :label="2">卡片短信</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="编辑短信:" v-if="form.smsType == 0">
              <div class="textarea">
                <el-input class="textareaChange" type="textarea" :rows="5" placeholder="请输入内容" v-model="form.content" @paste.native="shopLinkCheck($event, insertCoupon)">
                </el-input>
                <div class="footInfo">
                  <div>
                    <button class="select" @click.prevent="templateShow = true">
                      选择模板
                    </button>
                    <button class="keep" @click.prevent="handleShowModule">
                      保存模板
                    </button>
                    <span>已输入
                      <span style="color: #fe4d45">{{ form.content.length + (suffixList[0] ? suffixList[0].length : 0) + 8
                      }}</span>
                      个字（含签名及退订文字），预计
                      {{ Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}
                      条短信
                    </span>
                  </div>
                  <div class="ask-content">
                    <span style="
                            font-weight: normal;
                            margin-left: 8px;
                            color: #7f85e9;
                          ">计费规则</span>
                    <el-tooltip class="item" effect="light" placement="top-start" style="color:#999;">
                      <div v-html="content1" slot="content"></div>
                      <span class="question_icon" style="margin-left: 4px">?</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="footTips" style="height: 180px; position: relative">
                <img src="@/assets/images/new_icon_waring_yellow.png" style="
                        display: inline-block;
                        float: left;
                        position: absolute;
                        width: 14px;
                        height: 14px;
                        color: #ffffff;
                        margin: 0px 4px 0 0;
                        top: 9px;
                      " />
                <span style="margin-left: 22px; line-height: 21px">
                  (1) 短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链;
                  <br />
                  (2) 生成短链后建议复制到手机浏览器打开确保短链接能正常打开。
                  <br />
                  (3) 包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接 (示例：点击加购x商品详情页> 3.cn/1l-dAxxx)
                  <br/> 
                  (4) 短网址点击数据由官方返回，部分链接（如含中间页跳转，非原始链接）官方不支持埋点，因此无短网址点击数据
                  <br/>
                  (5) 原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                </span>
              </div>
            </el-form-item>
            <!-- 类型为富信显示 -->
            <el-form-item :label="isMediaQualification ? '富信模板:' : ''" v-if="form.smsType == 1 && isMedialSms" v-loading="editLoading">
              <div v-if="isMediaQualification">
                <el-select v-model="mediaId" @change="changeMedia"  filterable>
                  <el-option v-for="(item, index) in mediaOptionList" :key="index" :value="item.id"
                    :label="item.name"></el-option>
                </el-select>
                <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addMediaModule">添加模板</span>
              </div>
              <div v-else>
                <div class="notShow">
                  <img src="@/assets/images/未开通富信.png" alt="">
                  <p>您还未开通富信营销功能</p>
                  <div class="bottom-btn">
                    <button class="select" style="width: 136px;" @click.prevent="checkOut">
                      查看富信营销案例
                    </button>
                    <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
                      去提交资质申请开通
                    </button>
                  </div>
                </div>
                <sms-info-template v-if="smsInfoTemplateShow" @close="handleCloseSmsInfo1" :isShow="smsInfoTemplateShow" />
              </div>
            </el-form-item>
            <el-form-item label="卡片模板:" v-if="form.smsType == 2">
              <div v-if="isMediaQualification">
                <el-select v-model="cardId" @change="changeCard"  filterable>
                  <el-option v-for="(item, index) in cardOptionList" :key="index" :value="item.id"
                    :label="item.name"></el-option>
                </el-select>
                <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardModule">添加模板</span>
              </div>
              <div v-else>
                <div class="notShow">
                  <img src="@/assets/images/未开通富信.png" alt="">
                  <p>您还未开通卡片短信营销功能</p>
                  <div class="bottom-btn">
                    <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
                      去提交资质申请开通
                    </button>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="回落类型:" v-if="form.smsType == 2 && isMediaQualification" >
              <el-radio-group v-model="failBackConfig.failBackType" style="display: inline-block;">
                <el-radio label="0">不回落</el-radio>
                <el-radio label="1">回落普通短信</el-radio>
                <el-radio label="2">回落富信</el-radio>
              </el-radio-group>
              <span style="margin-left: 8px; font-size: 14px; cursor: pointer;color: #7f85e9" >
                    回落说明
                    <el-tooltip 
                      class="item"
                      effect="light"
                      placement="top-start">
                      <div slot="content">
                        温馨提示：<br />
                        由于卡片短信目前只支持全部华为机型和部分的小米机型，其他类型收集无法接收卡片短信<br/>
                        所以建议设置回落短信，设置后指定机型收到的短信为卡片短信，其他手机收到的均为普通短信。
                      </div>
                      <span class="question_icon">!</span>
                    </el-tooltip>
                  </span>
            </el-form-item>
            <el-form-item label="编辑短信:" v-if="form.smsType == 2 && isMediaQualification && failBackConfig.failBackType == 1">
              <div class="textarea">
                <el-input class="textareaChange" type="textarea" :rows="5" placeholder="请输入内容" v-model="failBackConfig.content" @paste.native="shopLinkCheck($event, insertCoupon)">
                </el-input>
                <div class="footInfo">
                  <div>
                    <button class="select" @click.prevent="templateShow = true">
                      选择模板
                    </button>
                    <button class="keep" @click.prevent="handleShowModule">
                      保存模板
                    </button>
                    <span>已输入
                      <span style="color: #fe4d45">{{ failBackConfig.content.length + (suffixList[0] ? suffixList[0].length : 0) + 8
                      }}</span>
                      个字（含签名及退订文字），预计
                      {{ Math.ceil(sendFailInfoLength > 70 ? sendFailInfoLength / 67 : sendFailInfoLength / 70) }}
                      条短信
                    </span>
                  </div>
                  <div class="ask-content">
                    <span style="
                            font-weight: normal;
                            margin-left: 8px;
                            color: #7f85e9;
                          ">计费规则</span>
                    <el-tooltip class="item" effect="light" placement="top-start" style="color:#999;">
                      <div v-html="content1" slot="content"></div>
                      <span class="question_icon" style="margin-left: 4px">?</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="footTips" style="height: 180px; position: relative">
                <img src="@/assets/images/new_icon_waring_yellow.png" style="
                        display: inline-block;
                        float: left;
                        position: absolute;
                        width: 14px;
                        height: 14px;
                        color: #ffffff;
                        margin: 0px 4px 0 0;
                        top: 9px;
                      " />
                <span style="margin-left: 22px; line-height: 21px">
                  (1) 短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链;
                  <br />
                  (2) 生成短链后建议复制到手机浏览器打开确保短链接能正常打开。
                  <br />
                  (3) 包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接 (示例：点击加购x商品详情页> 3.cn/1l-dAxxx)
                  <br/> 
                  (4) 短网址点击数据由官方返回，部分链接（如含中间页跳转，非原始链接）官方不支持埋点，因此无短网址点击数据
                  <br/>
                  (5) 原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                </span>
              </div>
            </el-form-item>
            <el-form-item label="辅助工具:" v-if="form.smsType == 2 && isMediaQualification && failBackConfig.failBackType == 1">
              <div class="tool">
                <p @click.prevent="insertShortUrlShow = true"><i class="iconfont iconbtn_duanwangzhi"></i>插入短网址</p>
              </div>
            </el-form-item>
            <el-form-item label="富信模板:" v-if="form.smsType == 2 && isMediaQualification && failBackConfig.failBackType == 2">
              <el-select v-model="failBackConfig.mediaTemplateId" @change="changeFailMedia"  filterable>
                  <el-option v-for="(item, index) in mediaOptionList" :key="index" :value="item.mediaTemplateId"
                    :label="item.name"></el-option>
                </el-select>
                <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addMediaModule">添加模板</span>
            </el-form-item>
            <div v-if="isMediaQualification || form.smsType == 0">
              <el-form-item label="短信签名:">
                <div class="btnList">
                  <div class="btnBox" v-for="(item, index) in suffixList" :key="'label' + index"
                    @click.prevent="switchSuffix(item)">
                    <button class="btn">{{ item }}</button>
                    <span class="check" v-if="form.smsSuffix === item">
                      <i class="el-icon-check"></i>
                    </span>
                  </div>
                  <span style="font-size: 14px; cursor: pointer" class="btnListButtom" @click="replaceSignature">更换</span>
                </div>
              </el-form-item>

              <el-form-item label="辅助工具:" v-if="form.smsType == 0 || isMedialSms == false">
                <div class="tool">
                  <p @click.prevent="insertShortUrlShow = true"><i class="iconfont iconbtn_duanwangzhi"></i>插入短网址</p>
                </div>
              </el-form-item>

              <el-form-item label="会员过滤:">
                <!-- <el-checkbox-group > -->
                <el-checkbox :label="1" v-model="form.blackFlag">
                  黑名单
                  <span @click.stop="toBlack" style="color: #7f85e9; margin-left: 8px">设置黑名单</span>
                </el-checkbox>
                <el-checkbox :label="true" v-if="isPreEvaluate" v-model="form.badReviewFilterSetting">
                  给过中差评客户
                </el-checkbox>
                <el-checkbox :label="true" v-if="isPreRefund" v-model="form.refundFilterSetting">
                  退过款客户
                </el-checkbox>
                <!-- </el-checkbox-group> -->
              </el-form-item>

              <el-form-item label="短信过滤">
                <div style="display: flex">
                  <el-radio-group v-model="form.fitlerDay">
                    <el-radio :label="0">不过滤</el-radio>
                    <el-radio :label="3">3天</el-radio>
                    <el-radio :label="5">5天</el-radio>
                    <el-radio :label="7">7天</el-radio>
                    <el-radio :label="15">15天</el-radio>
                    <el-radio :label="99">天内发送过的客户</el-radio>
                  </el-radio-group>
                  <el-input v-model="sendOutIpt" placeholder="填写发送数" style="width: 120px; marginleft: 8px"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="短信测试:">
                <div class="test" v-if="form.smsType == 0 || isMedialSms == false">
                  <!-- <el-input v-model="smsTest" placeholder="输入测试号码" class="ipt"
                    @change="sendMobileChange"></el-input> -->
                    <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                          <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                  <button class="sendTest" @click.prevent="sendSmsTest(true)">
                    发送短信测试
                  </button>
                  <button class="record" @click.prevent="smsDialogs = true">
                    短信记录
                  </button>
                  <button class="record" style="width: auto;padding-left:4px;padding-right:4px;" @click.prevent="updataPhone">
                    修改测试手机号
                  </button>
                </div>
                <div class="test" v-else>
                  <!-- 需开启富信测试后才可选择测试手机号 -->
                  <!-- <el-checkbox v-model="isRichSmsTest" style="margin-right: 10px;">富信测试</el-checkbox> -->
                  <el-select v-model="mediaTestMobilesList" multiple collapse-tags placeholder="请选择"
                    style="width: 264px;vertical-align: top;" @change="selectMediaTestMobiles">
                    <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                  <el-button style="margin-left: 8px;" class="record1" @click="sendRichTest">发送测试短信</el-button>
                  <el-button class="record" style="margin-right: 0px;" @click="smsDialogs = true">短信记录</el-button>
                  <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="updataPhone">修改测试手机号</span>
                </div>
                <div class="media-info" v-if="form.smsType == 1">
                  <i class="el-icon-warning warning-icon"></i>
                  <p>注：短信测试号码为申请签名时报备的号码,且发送测试短信不受频控限制。</p>
                  <!-- <p style="color: #FE4D45;">2.官方富信测试规则：富信测试短信和正式短信 一起创建，当运营商审核通过后
                    ，测试短信会立即发出，等到设置的发送时间就发正式短信。如收到测试短信不正常，可以选择取消正式发送的批次任务。</p> -->
                </div>
              </el-form-item>

              <el-form-item label="发送时间:">
                <div>
                  <el-date-picker class="pickerTime" v-model="sendStart" type="date" format="yyyy-MM-dd"
                    @change="dateChange" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="expireTimeOption1"
                    style="width: 136px"></el-date-picker>

                  <el-time-picker class="pickerTime" v-model="sendEnd" format="HH:mm:ss" value-format="HH:mm:ss"
                    :picker-options="expireTimeOption2" placeholder="选择时间"
                    style="margin-left: 8px; width: 136px"></el-time-picker>
                </div>
              </el-form-item>
              <!-- <festivals></festivals> -->
              <!-- <div style="width:950px;line-height:22px;color:red;margin-top:-10px;margin-bottom:4px">
                <div> 注意：</div>
                <div>
                  <span>
                    (1) 双11大促期间短信发送时间：10月14日、10月15日、10月23日、10月24日、10月31日、11月1日、11月10日、11月11日 9:00-24:00；10月16日-10月22日、10月25日-10月30日、11月2日-11月9日 9:00-21:00；11月12日起恢复正常，即   09:00-20:00（*包含普通短信、富信、卡片短信）</span
                  >
                </div>
                <div>
                  (2) 10月14日-11月11日大促期频控规则：同一店铺 2 天内给同一手机号发送商家营销短信的条数不超过 1条;每个手机号每 1天只能收到 5 条商家营销短信,每 2天只能收到 10 条商家营销短信（*商家营销短信包括普通短信、富信、卡片短信）
                </div>
              </div> -->
            </div>
          </el-form>
          <div class="activeTip">{{ globalActivityTip }}</div>
       
          <!-- 短信预览效果 -->
          <div class="xiao-hug xiao_hug2" v-if="form.smsType == 0 || isMedialSms == false">
            <div style="margin: 0 auto; width: 256px">
              <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
                <div class="message-content">【{{ form.smsSuffix }}】{{ form.content }}{{ TTip }}</div>
              </div>
              <div class="mobile-tips">短信预览效果</div>
            </div>
          </div>
          <div class="xiao-hug xiao_hug2" v-if="form.smsType == 1">
            <div>
              <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">  
                <sms-info-body v-if="mediaId && preMediaShow" :key="mediaId" :title="smsInfoRowData.title" :text="smsInfoRowData.text" :mediaListJsonArray="smsInfoRowData.mediaList"></sms-info-body>
              </div>
              <div class="mobile-tips">富信预览效果</div>
            </div>
          </div>
          <div class="xiao-hug xiao_hug2" v-if="form.smsType == 2">
            <div>
              <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">  
                <sms-info-card-body v-if="cardId && preCardShow" :key="mediaTemplateId" :id="mediaTemplateId" ></sms-info-card-body>
              </div>
              <div class="mobile-tips">卡片预览效果</div>
            </div>
          </div>
        </section>

        <!-- 底部发送 -->
        <div v-if="isMediaQualification || form.smsType == 0">
          <footer class="foot">
            <button class="btn" @click="sendSmsTest(false)">发送</button>
            <p class="txt" v-if="form.smsType == 0 || isMedialSms == false">
              共筛选出
              <span style="color: #fe4d45">{{ sendObjectCount }}</span> 会员， 预计消耗短信
              <span style="color: #fe4d45">{{ sendObjectCount * Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 :
                sendInfoLength / 70) }}</span>
              条 (当前短信余额
              <span class="num">
                {{ this.$store.getters.loginUserInfo.paySmsTotal - this.$store.getters.loginUserInfo.useSmsTotal || "--" }}
              </span>
              条)
            </p>
            <p class="txt" v-if="form.smsType == 1 && isMedialSms">
              共筛选出
              <span :style="{ color: globalBG }">{{ sendObjectCount }}</span>
              会员，预计消耗短信
              <span :style="{ color: globalBG }">{{
                fxSmsUseNum
              }}</span>
              条，其中包括测试短信<span class="num" :style="{ color: globalBG }">{{ mediaTestMobilesList.length }}</span>条
              (当前富信余额
              <span class="num" :style="{ color: globalBG }">{{ fuxinSms }}</span>
              条)
            </p>
            <p class="txt" v-if="form.smsType == 2 && isMedialSms">
              共筛选出
              <span :style="{ color: globalBG }">{{ sendObjectCount }}</span>
              会员，预计消耗短信
              <span :style="{ color: globalBG }">{{
                fxSmsUseNum
              }}</span>
              条 (当前卡片短信余额
              <span class="num" :style="{ color: globalBG }">
                {{
              this.$store.getters.loginUserInfo.payCardSmsTotal -
                this.$store.getters.loginUserInfo.useCardSmsTotal || "--"
              }}
              </span>
              条)
            </p>
          </footer>
        </div>
      </div>
    </el-drawer>

    <!-- 选择模板 -->
    <sms-template v-if="templateShow" :isShow="templateShow" @close="templateChange"></sms-template>

    <!-- 保存模板 -->
    <my-popup title="保存模板" width="370" zIndex="3330" :flag="keepTmpShow" @close="keepTmpChange">
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select v-model="keepTmpValue" placeholder="请选择" style="width: 240px">
            <el-option v-for="(item, index) in dirList" :key="index" :label="item.title" :value="item.tid"></el-option>
            <!-- <el-option label="云短信旗舰店专用" :value="1"></el-option>
            <el-option label="太阳短信旗舰店专用" :value="2"></el-option>
            <el-option label="月亮短信旗舰店专用" :value="3"></el-option>-->
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 插入短链接 -->
    <insert-short-dialog v-if="insertShortUrlShow" :typeSms="2" :zIndex="3000"
      @close="insertUrlChange"></insert-short-dialog>

    <!-- <insert-coupon-url
      v-if="insertShortUrlShow"
      @close="insertUrlChange"
    ></insert-coupon-url> -->

    <!-- 插入优惠券链接 -->
    <insert-coupon-link v-if="insertCouponShow" :isShow="insertCouponShow"
      @close="insertCouponChange"></insert-coupon-link>

    <!-- 发送确认 -->
    <my-popup :flag="sendSmsTestState" title="发送确认" @close="sendSmsTestClose" width="500">
      <div class="sendSmsTestWrap">
        <p class="detailsInfo" v-if="form.smsType == 0 || isMedialSms == false">
          <span v-if="isTestSend">提交号码为<span style="color: #fe4d45">{{ smsTest && smsTest.split(",").length }}
            </span></span>
          <span v-else>发送人数为<span style="color: #fe4d45">{{ sendObjectCount }} </span>，</span>
          当前短信字数为
          <span style="color: #fe4d45">{{ sendInfoLength }} </span>字，每条短信以

          <span style="color: #fe4d45">{{ Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}
          </span>
          条计费，
          <span v-if="isTestSend">提交
            <span style="color: #fe4d45">
              {{ smsTest && smsTest.split(",").length * Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 :
                sendInfoLength / 70) }}
            </span>
            条短信，以实际发送条数为准！</span>
          <span v-else>提交
            <span style="color: #fe4d45">
              {{ sendObjectCount * Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}
            </span>
            条短信，以实际发送条数为准！</span>
        </p>
        <div v-else-if="form.smsType == 1" style="line-height: 30px;text-align: left;">
          <div>
            <span v-if="!isTestSend">
              发送人数：
              <span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>人
            </span>
          </div>
          <div>
            富信内容：{{ form.mediaTitle }}
          </div>
          <div>
            富信大小：<span :style="{ color: globalBG }">{{ richMessageData.totalSize }}M</span>
          </div>
          <div>
            富信计费条数：<span :style="{ color: globalBG }">1</span>条
          </div>
          <div>
            提交条数：<span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>条
          </div>
        </div>
        <div v-else-if="form.smsType == 2" style="line-height: 30px;text-align: left;">
          <div>
            <span v-if="!isTestSend">
              发送人数：
              <span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>人
            </span>
          </div>
          <div>
            卡片短信内容：{{ cardName }}
          </div>
          <div>
            卡片短信计费条数：<span :style="{ color: globalBG }">1</span>条
          </div>
          <div>
            提交条数：<span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>条
          </div>
        </div>
        <el-button @click="sendSmsTestState = false">取消</el-button>
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <smsTemplatesX v-if="smsDialogs" :isCard="form.smsType == 2" :isMedia="form.smsType == 1" :smsDialog="smsDialogs" @transferName="transferName" @close="smsDialogClose" />
    <!-- 发送成功提示 -->
    <el-dialog :visible.sync="successDialog" title="提示" width="400px" append-to-body custom-class="send-con-dialog">
      <div class="success-tip">
        <img src="@/assets/images/tip_success.png" />
        <span>亲，短信已经成功提交了哦！</span>
      </div>
      <div class="btn-group">
        <el-button @click="handleViewRecord">查看记录</el-button>
        <el-button type="primary" @click="handleConSending">继续发送</el-button>
      </div>
    </el-dialog>
        <!-- 去设置弹层 -->
        <SetDialog :visible="setDialogVisible" @close="setDialogVisible = false"></SetDialog>
    <!-- 修改号码弹窗 -->
    <el-dialog title="修改测试短信号码" :customClass="'message-zindex'" :visible.sync="showDialogOne" width="460px" style="min-width: 1100px">
      <template slot="title">
        <span>修改测试短信号码</span>
      </template>
      <div class="dialog-wrapper">
        <!-- <div class="item">
          <span class="item-title">短信测试：</span>
          <el-input size="small" class="input" v-model="testMobiles"></el-input>
        </div> -->
        <div class="remarks">
          <div>请前往【京东云舟】-【工具】-【短信工具】-【短信签名】中进行修改号码中操作</div>
          <!-- <img class="img" src="@/assets/images/new_icon_waring.png" /> -->
          <!-- <span>注：填写测试号码，在测试发送时无需审核短信内容。</span> -->
          <!-- <div>1、测试短信手机号不受频控限制，最多填写15个，多个之间用英文逗号分隔；</div>
          <div>2、修改完成后立即生效，且测试手机号的修改会应用到全部渠道；</div>
          <div>3、每天修改手机号的次数上限为5次；</div> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">关闭</el-button>
        <!-- <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">取消</el-button>
        <el-button @click="mobilPhoneSubmit" type="primary" style="width: 96px">提交</el-button> -->
      </span>
    </el-dialog>

    <sendTestMediaConfirm 
      v-if="sendTestMediaConfirmShow"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="sendTestMediaConfirmShow = false"
      :source="2"
      :mediaTestMobilesList="mediaTestMobilesList"
      :id="mediaId"
      :mediaTemplateId="mediaTemplateId">
    </sendTestMediaConfirm>
    <sendTestCardConfirm 
      v-if="sendTestCardConfirmShow"
      @close="sendTestCardConfirmShow = false" 
      @confirm="sendTestCardConfirmShow = false"
      :source="2"
      :mediaTestMobilesList="mediaTestMobilesList"
      :title="cardName"
      :mediaTemplateId="mediaTemplateId">
    </sendTestCardConfirm>
    <!-- 短信内容预览 -->
    <sms-info v-if="smsInfoShow" @close="handleCloseSmsInfo" :isShow="smsInfoShow" :id="smsInfoRowData.contentId"
      :title="smsInfoRowData.title" :text="smsInfoRowData.text" />
      
      <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import sendTestMediaConfirm from './sendTestMediaConfirm';
import sendTestCardConfirm from './sendTestCardConfirm';
import { getSeller } from "@/api/richSms";
import smsTemplate from "../sms_template";
import { mapState, mapGetters } from "vuex";
import myPopup from "../../../components/myPopup";
import smsTemplatesX from "../../../components/sms-templates-x-drawer";
import insertCouponLink from "../insert_coupon_link";
import insertCouponUrl from "./insert-short-url";
import { smsSend } from "@/api/smsController";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { preCommit,NewPreCommit, platformSend, getSendTime, getValidSmsTestMobiles,getMediaList,getCardList } from "@/api/smsSend";
import { getTemplateDir, createTemplate, getSmsMediaTemplate, getSmsMediaTemplateDetail, smsMediaTemplateSave } from "@/api/smsTemplates";
import insertShortDialog from "@/components/insert-short-dialog";
import { updateSuffixMobileById } from "@/api/backstage/messageBill";
// 富信组件
import richMessage from "@/components/rich-message";
import smsInfo from "@/components/sms-info";
import smsInfoTemplate from "@/components/sms-info-template";
import smsInfoBody from "@/components/sms-info-body";
import smsInfoCardBody from "@/components/sms-info-card-body";
import SetDialog from "@/components/SetDialog";
import changetestphone from "@/components/changetestphone.vue";

export default {
  props: {
    drawer: {
      // 显示隐藏状态控制
      type: Boolean,
      default: false,
    },
    checkData: {
      // 列表选中的数据
      type: Array,
      default: () => {
        return [];
      },
      require: true,
    },
    sendType: {
      // 发送类型 1 按条件查询 2 勾选 3 按会员分组 0 其他
      type: Number,
    },
    taskName: {
      // 任务名称
      type: String,
    },
    dataFrom: {
      // 数据来源类型 0 测试短信 1 会员发送 2 订单发送 4 输入号码发送 5 指定号码发送 6 变量短信发送 7 手动催评 8 手动回评 9 手动审核退款 10 营销汇总分析发送
      type: Number,
    },
    dataFromStr: {
      type: String,
    },
    count: {
      // 发送人数
      type: Number,
    },
    searchForm: {
      // 存储按查询结果发送短信需要的查询参数
      type: Object,
    },
    isMedialSms: {
      // 是否开启富信
      type: Boolean,
      default: false
    },
  },
  components: {
    smsTemplate,
    myPopup,
    insertCouponLink,
    insertCouponUrl,
    smsTemplatesX,
    insertShortDialog,
    richMessage,
    smsInfo,
    smsInfoBody,
    smsInfoTemplate,
    sendTestMediaConfirm,
    SetDialog,
    sendTestCardConfirm,
    smsInfoCardBody,
    changetestphone
  },
  watch: {
    drawer(newVal) {
      if (newVal) {
        
        this.limitSendTime();
        this.getOfficialSuffix(); // 获取店铺签名
        this.form.title = this.taskName + this.getNowDate(); // 活动主题
        // 预提交接口
        this.sendObjectCount = 0;
        this.sendObjectId = "";
        this.handlePreSend();
        this.form.smsType = 0;
        getSeller().then(res => {
          this.editLoading = false;
          if (res.code == 1) {
            this.isMediaQualification = res.data.isMediaQualification
            if(this.isMediaQualification){
              this.getMediaOption('');
              this.getCardOption('');
            }
          }
        }).catch(err => {
          this.editLoading = false;
        });
      }
    },
    permissions(nVal, oVal) {
      if (nVal.indexOf("hide:filter:refund") != "-1") {
        this.isPreRefund = true;
      }
      if (nVal.indexOf("hide:filter:evaluate") != "-1") {
        this.isPreEvaluate = true;
      }
    },
    // 监听是否勾选富信测试
    isRichSmsTest() {
      if (!this.isRichSmsTest) {
        this.form.mediaTestMobiles = ''
        this.mediaTestMobilesList = []
      }
    },
    'form.smsType': {
      handler(nVal) {
        // console.log('短信类型',nVal);
        if (this.isMedialSms) {
          if (nVal == 0) {
            // this.clearBuriedPoint()
          } else if(nVal == 1){
            if (this.dataFromStr == '会员列表') {
              this.buriedPoint(2, '会员列表/富信', "客户管理", "会员管理")
            }
          } else {
            if (this.dataFromStr == '会员列表') {
              this.buriedPoint(2, '会员列表/卡片短信', "客户管理", "会员管理")
            }
          }
        }
      },
      immediate: true,
    }
  },
  computed: {
    ...mapState({
      globalActivityTip: "globalActivityTip",
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),

    ...mapGetters(["loginUserInfo"]),

    content1() {
      return (
        "<div>1.70个字计1条短信，超过70字按照67字每条计费。</div>" +
        "<div>2.一个汉字，字母或标点空格都算作一个字。</div>" +
        '<div>3.带标签短信以实际发送为准，有可能超过默认字数。</div>' +
        '<div>4."签名"与"拒收请回复R"包含在字数中。</div>' +
        '<div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>' +
        '<div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>'
      );
    },
    sendInfoLength() {
      try {
        if (this.form.content) {
          return this.form.content.length + this.form.smsSuffix.length + 2 + this.TTip.length;
        } else {
          return 0;
        }
      } catch (e) {
        return 0;
      }
    },
    sendFailInfoLength() {
      try {
        if (this.failBackConfig.content) {
          return this.failBackConfig.content.length + this.form.smsSuffix.length + 2 + this.TTip.length;
        } else {
          return 0;
        }
      } catch (e) {
        return 0;
      }
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    // 富信预计消耗条数
    fxSmsUseNum() {
      // 不限制发送人数
      return this.sendObjectCount + this.mediaTestMobilesList.length
    },
  },
  mounted() {
    console.log('进入', this.form);
    // this.getOfficialSuffix();
    if (this.permissions && this.permissions.indexOf("hide:filter:refund") != "-1") {
      this.isPreRefund = true;
    }

    if (this.permissions && this.permissions.indexOf("hide:filter:evaluate") != "-1") {
      this.isPreEvaluate = true;
    }
    // 获取测试手机号
    getValidSmsTestMobiles().then(res => {
      if (res.code == 1) {
        this.testOptions = res.data.smsTestMobiles
        this.testMobiles = res.data.smsTestMobiles.join(',')
        this.textPhoneId = res.data.id
      }
    })
    this.fuxinSms = sessionStorage.getItem('fuxin')
  },
  data() {
    return {
      Selectmobiles:[],
      cardName:'',
      editLoading: true,
      preMediaShow:false,
      preCardShow:false,
      smsInfoTemplateShow:false,
      sendTestMediaConfirmShow:false,
      sendTestCardConfirmShow:false,
      isMediaQualification:false,
      mediaId:null,
      cardId:null,
      mediaTemplateId:null,
      mediaOptionList:[],
      cardOptionList:[],
      setDialogVisible:false,
      dirList: [{
        title:'555555',
        tid:'236589'
      }],
      sendObjectCount: 0,
      preLoading: false,
      sendObjectId: "",
      isPreRefund: false, // 过滤退过款
      isPreEvaluate: false, // 过滤给过中差评客户
      // 回落数据
      failBackConfig:{
        failBackType:'0',
        content:'',
        jdShortLink:'',
        realUrl:'',
        mediaTemplateId:'',
        mediaMulitiFileId:'',
      },
      successDialog: false,
      // 表单数据
      form: {
        title: "",
        content: "",
        blackFlag: false,
        badReviewFilterSetting: false,
        refundFilterSetting: false,
        fitlerDay: 0,
        smsSuffix: "",
        sendTime: "",
        url: "",
        smsType: 0, //短信类型
        mediaTestMobiles: '', // 富信测试手机号
        mediaTitle: '', // 富信标题
        mediaList: [], // 富媒体列表
      },
      //保存模板数据
  
      // 短链接
      insertCoupon: "",
      // 短链接原地址
      url: "",
      // 短信测试值
      smsTest: null,
      // 短信签名列表
      suffixList: [],
      sendOutIpt: null,
      // 短信模板状态控制
      templateShow: false,
      // 保存模板状态控制 ---- 内容
      keepTmpShow: false,
      keepTmpValue: "",
      // 插入短链接状态控制 ----- 内容
      insertShortUrlShow: false,
      insertUrlValue: null,
      //短信记录弹窗
      smsDialogs: false,
      // 插入优惠券链接控制
      insertCouponShow: false,
      // 京东跳转App链接控制 ---- 内容
      jdJumpLinkShow: false,
      jumpLinkSelectValue: 0,
      jumpLinkIptValue: null,
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      // 发送时间
      sendStart: "",
      sendEnd: "",
      expireTimeOption1: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7 || date.getTime() > Date.now() + 8.64e7 * 90;
        },
      },
      expireTimeOption2: {
        selectableRange: "9:00:00 - 19:55:59",
      },
      limitTime: {},
      TTip: "拒收请回复R",
      // 发送短信确认弹窗状态
      sendSmsTestState: false,
      isTestSend: false,
      richMessageData: {}, // 富信组件传递的参数
      isRichSmsTest: false, // 是否富信测试短信
      mediaTestMobilesList: [], // 选中测试手机号
      testOptions: [], // 富信测试手机号列表
      showDialogOne: false, // 修改测试手机号弹窗
      testMobiles: '', // 修改测试手机号
      textPhoneId: '', // 修改测试手机号ID
      selectTempleteShowDialog: false, // 富信选择模板
      richkeepTmpShow: false, // 富信保存模块弹窗
      smsInfoShow: false, // 短信预览弹窗
      smsInfoRowData: {}, // 短信详情数据
      selectTemplateData: [],// 选择模板
      mediaTemplateForm: {  // 富信选择模板列表查询
        size: 10,
        current: 1
      },
      templatePaginationInfo: {  // 选择模板分页器
        current: 1,
        size: 10,
        total: 2
      },
      richtemplateName: '', // 富信保存模板名称
      returnData: {
        totalSize: 0, // 总大小
        mediaTitle: "", // 短信标题
        content: '', // 文本内容
        mediaList: [], // 富媒体列表
        jdSmsSuffix: '', // 短信签名
        sourceUrl: '' // 原链接
      }, // 富信回显
      fuxinSms: 0, // 富信余额
      tableLoading: false,
    };
  },
  methods: {
    selectTestMobiles(){
      this.smsTest = this.Selectmobiles.join(',')
    },
    // 查看富信营销案例
    checkOut() {
      this.smsInfoTemplateShow = true
    },
    // 关闭富信营销案例弹窗
    handleCloseSmsInfo1() {
      this.smsInfoTemplateShow = false
    },
    // 提交资质申请开通
    toSubmit() {
      // 跳转至  后台管理-富信资质
      this.$router.push({ name: 'media_qualification' })
    },
    addMediaModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "5" },
      });
      window.open(routeUrl.href, "_blank");
    },
    addCardModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "6" },
      });
      window.open(routeUrl.href, "_blank");
    },
    getMediaOption(name){
      getMediaList({name}).then(res=>{
        if(res.code == 1){
          this.mediaOptionList = res.data
        }else{
          this.$message.error(res.message)
        }
      })
    },
    getCardOption(name){
      getCardList({name}).then(res=>{
        if(res.code == 1){
          this.cardOptionList = res.data
        }else{
          this.$message.error(res.message)
        }
      })
    },
    changeMedia(){
      let row = this.mediaOptionList.find(o=>o.id == this.mediaId)
      this.mediaTemplateId = row.mediaTemplateId
      this.preMediaShow = false;
      getSmsMediaTemplateDetail(this.mediaId).then(res => {
        if (res.code == 1) {
          let data = res.data
          this.returnData.mediaTitle = data.title
          this.returnData.totalSize = data.totalSize
          this.returnData.content = data.text
          this.returnData.mediaList = data.mediaList
          this.returnData.sourceUrl = data.originUrl
          this.returnData.jdShortLink = data.jdShortLink

          this.richMessageData.mediaTitle = data.title
          this.richMessageData.totalSize = data.totalSize
          this.richMessageData.content = data.text
          this.richMessageData.mediaList = data.mediaList
          this.richMessageData.sourceUrl = data.originUrl
          this.richMessageData.jdShortLink = data.jdShortLink
          this.smsInfoRowData = res.data
          this.preMediaShow = true;
        }
      })
    },
    changeCard(){
      let row = this.cardOptionList.find(o=>o.id == this.cardId)
      this.mediaTemplateId = row.mediaTemplateId
      this.form.mediaTitle = row.title;
      this.form.content = row.text;
      this.cardName = row.title;
      this.preCardShow = true;
    },
    changeFailMedia(){
      let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.failBackConfig.mediaTemplateId)
      getSmsMediaTemplateDetail(row.id).then(res=>{
        let data = res.data
        this.failBackConfig.content = data.text
        this.failBackConfig.jdShortLink = data.jdShortLink
        this.failBackConfig.realUrl = data.originUrl
        this.failBackConfig.mediaMulitiFileId = data.mediaMulitiFileId
      })
    },
    // 修改测试手机号弹窗
    updataPhone() {
      this.showDialogOne = true
    },
    getVali(){
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
        this.testOptions = res.data.smsTestMobiles
        this.testMobiles = res.data.smsTestMobiles.join(',')
        this.textPhoneId = res.data.id
      }
      })
    },
    // 修改测试手机号确认弹窗
    mobilPhoneSubmit() {
      updateSuffixMobileById({
        smsTestMobiles: this.testMobiles,
        id: this.textPhoneId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.form.mediaTestMobiles = ''
            this.mediaTestMobilesList = [];
            this.getVali();
            this.showDialogOne = false
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => { });
    },

    // 查看短信内容
    showTemplateInfo(val) {
      getSmsMediaTemplateDetail(val.id).then(res => {
        if (res.code == 1) {
          this.smsInfoRowData = res.data
          this.smsInfoRowData.contentId = val.mediaMulitiFileId
          this.smsInfoShow = true
        }
      })
    },
    // 关闭短信内容弹窗
    handleCloseSmsInfo() {
      this.smsInfoShow = false
    },

    dateChange(val) {
      var nowTime10 = this.getNowDate2();
      var time1 = nowTime10.substring(0, 10);
      var time2 = nowTime10.substring(11, 19);
      var startTime = this.limitTime.startTime;
      var endTime = this.limitTime.endTime;
      // var time2 = "20:58:59";
      var arr = time2.split(":");
      var endArr = endTime.split(":");

      // 最晚可以选到时间
      if (arr[0] > endArr[0]) {
        time2 = endTime;
      } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
        time2 = endTime;
      } else if (arr[0] == endArr[0] && arr[1] == endArr[1] && arr[2] >= endArr[2]) {
        time2 = endTime;
      }

      // 选择时间为空
      this.sendEnd = "";

      if (val == time1) {
        this.expireTimeOption2.selectableRange = time2 + " - " + endTime;
      } else {
        this.expireTimeOption2.selectableRange = startTime + " - " + endTime;
      }
    },

    // 富信测试手机号 
    selectMediaTestMobiles(val) {
      this.form.mediaTestMobiles = this.mediaTestMobilesList.join(',')
      console.log(this.form.mediaTestMobiles);
    },

    //判读时间函数
    expireTimeOption3() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1 < 10 ? "0" + new Date().getMonth() + 1 : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate();
      let dd1 = `${yy}-${mm}-${dd}`;
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let mf1 = "00";
      let mf2 = "55";
      let mf4 = new Date().getMinutes() + 1;
      let mf3 = mf4 < 10 ? "0" + mf4 : mf4;
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      let ss3 = new Date().getSeconds() + 1 < 10 ? "0" + new Date().getSeconds() + 1 : new Date().getSeconds() + 1;
      //  console.log(mf3);
      //  console.log(ss3);
      //  console.log(mf4);
      let ss1 = "00";
      let ss2 = "59";

      if (dd1 == this.sendStart) {
        if (mf == 59 && hh < 19 && ss == 59) {
          console.log(111);
          // console.log(this.expireTimeOption2.selectableRange);
          this.expireTimeOption2 = {
            selectableRange: `${hh + 1}:${mf1}:${ss1} - ${19}:${mf2}:${ss2}`,
          };
        } else if (mf < 59 && hh < 19 && ss == 59) {
          console.log(222);
          this.expireTimeOption2 = {
            selectableRange: `${hh}:${mf3}:${ss1} - ${19}:${mf2}:${ss2}`,
          };
        } else if (mf < 59 && hh < 19 && ss < 59) {
          console.log(333);
          this.expireTimeOption2 = {
            selectableRange: `${hh}:${mf3}:${ss3} - ${19}:${mf2}:${ss2}`,
          };
          console.log(this.expireTimeOption2);
        } else if (hh == 19 && mf <= 55 && ss < 59) {
          this.expireTimeOption2 = {
            selectableRange: `${hh}:${mf3}:${ss3} - ${19}:${mf2}:${ss2}`,
          };
        } else if (hh == 19 && mf > 55) {
          this.sendStart = "";
          this.$message.warning("今日不可发送短信，请重新选择");
        } else if (hh > 19) {
          this.sendStart = "";
          this.$message.warning("今日不可发送短信，请重新选择");
        }
      } else {
        this.expireTimeOption2 = {
          selectableRange: "9:00:00 - 19:55:59",
        };
      }
    },
    getNowDate2() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      date.setMinutes(date.getMinutes() + 10);
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }

      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + Hours + seperator2 + Minutes + seperator2 + Seconds;

      return currentdate;
    },

    // 官方发送，发送时间的限制
    limitSendTime() {
      getSendTime().then((res) => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + " - " + res.data.endTime;
        this.expireTimeOption2.selectableRange = selectableRange;
      });
    },

    // 去设置
    hancdClick() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
        // query: { tabIndex: 2, groupName: 1 + ind },
      });
      window.open(routeUrl.href, "_blank");
    },
    // insertUrlValues(insertUrlValue) {
    //   // this.form.url = insertUrlValue;
    // },
    // 抽屉隐藏
    handleClose() {
      this.$emit("close", false);
      // return
      this.templateShow = false;
      // 清空数据
      this.form = {
        title: "",
        content: "",
        blackFlag: false,
        fitlerDay: 0,
        smsSuffix: "",
        sendTime: "",
        url: "",
        smsType: 0,
      };
      this.smsTest = null;
      this.sendStart = null;
      this.sendEnd = null;
    },
    // // 短信模板隐藏
    // templateChange(state, data) {
    //   this.templateShow = false;
    //   if (data)
    //     this.form.content = this.form.content
    //       ? this.form.content + data.content
    //       : data.content;
    // },
    // 继续发送
    handleConSending() {
      this.successDialog = false;
      this.handleClose();
    },
    // 查看记录
    handleViewRecord() {
      this.handleClose();
      this.successDialog = false;
      var path = "/marketing/marketing/member_send";
      if (this.dataFrom == "4") {
        path = "/marketing/marketing/designated_send";
      }
      if (this.dataFrom == "7" || this.dataFrom == "8" || this.dataFrom == "9") {
        path = "/backstage/backstage/sms_reply_record";
      }
      let routeUrl = null;
      if (this.loginUserInfo.venderType && this.dataFrom != "7"  ) {
        routeUrl = this.$router.resolve({
          path: "/marketing/marketing/self_order_send",
          query: { to: "focusShop" },
        });
      } else if(this.dataFrom == "7"){// 上线前提出 手动催评需要带条件
        routeUrl = this.$router.resolve({
          path: "/backstage/backstage/sms_reply_record",
          query: { 
            to: "focusShop",
            activityType: 7
          },
        });
      } else if(this.dataFrom == "8"){// 上线前提出 手动催评需要带条件
        routeUrl = this.$router.resolve({
          path: "/backstage/backstage/sms_reply_record",
          query: { 
            to: "focusShop",
            activityType: 8
          },
        });
      }else {
        routeUrl = this.$router.resolve({
          path: path,
          query: { to: "focusShop" },
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    // 保存模板隐藏
    templateChange(val, item) {
      console.log("选择模板的返回==", val, item);
      // this.inputContent = item.content;
      if (val == true) {
        if(this.form.smsType == 2 && this.failBackConfig.failBackType == 1){
          this.failBackConfig.content = item.content;
        }else{
          this.selectTemplate = item;
          // this.form.content = this.form.content ? this.form.content : "";
          this.form.content = item.content;

        }
       
      }
      this.templateShow = false;
    },

    // 保存模板 显示
   async handleShowModule() {
      var param = {
        type: 0,
      };
     await getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.keepTmpShow = true;
          this.dirList = res.data;
        } 
      });
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.form.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success({ message: "保存模板成功！", customClass: 'message-zindex' });
          } else {
            this.$message.error({ message: res.message, customClass: 'message-zindex' });
          }
        });
      }
    },
    //更换签名
    replaceSignature() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 插入短链接隐藏
    // insertUrlChange(state, data, url) {
    insertUrlChange(val, obj) {
      console.log("999", val, obj);
      this.insertShortUrlShow = false;
      if(this.form.smsType == 2 && this.failBackConfig.failBackType == 1){
        if (!val) {
          return;
        }
          this.failBackConfig.content += " " + obj.shortLink + " ",
          this.failBackConfig.jdShortLink = obj.shortLink,
          this.failBackConfig.realUrl = obj.originUrl;
      }else{
        
        if (!val) {
          return;
        }
        var data = obj.shortLink,
          url = obj.originUrl;
        console.log(data, url);

        if (this.insertCoupon == "") {
          this.insertCoupon = data;
          if (data) {
            let content = this.form.content ? this.form.content : "";
            this.form.content = content + " " + data + " ";
          }
        } else {
          if (data) {
            console.log(this.form.content && this.form.content.indexOf(this.insertCoupon) != -1);
            if (this.form.content && this.form.content.indexOf(this.insertCoupon) != -1) {
              this.form.content = this.form.content.replace(this.insertCoupon, data);
            } else {
              let content = this.form.content ? this.form.content : "";
              this.form.content = content + " " + data + " ";
            }
          }
        }
        this.url = url;
        this.insertCoupon = data;
        this.insertShortUrlShow = false;
      }
    },
    // 插入优惠券隐藏
    insertCouponChange(state, data) {
      this.insertCouponShow = false;
    },
    // 京东跳转App链接隐藏
    jdJumpLinkChange() {
      this.jdJumpLinkShow = false;
    },
    // 获取官方的短信签名
    getOfficialSuffix() {
      getPrecisionJdSuffixList(2).then((res) => {
        this.suffixList = res && res.data;
        console.log(res);
        this.form.smsSuffix = res && res.data[0];
        this.returnData.jdSmsSuffix = res.data[0]
      });
    },
    switchSuffix(item) {
      this.form.smsSuffix = item;
      this.returnData.jdSmsSuffix = item
    },
    // 跳转至黑名单页面
    toBlack() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 短信测试发送号码变化监听
    sendMobileChange() {
      this.smsTest = this.smsTest && this.smsTest.replace("，", ",");
    },
    //数组排重
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    // 区分发送短信类型
    async sendSmsTest(state = false) {

      if (this.form.smsType == 1) {
        this.form.content = this.richMessageData.content
        this.form.mediaTitle = this.richMessageData.mediaTitle
        this.form.mediaList = this.richMessageData.mediaList
        // if (this.form.mediaTitle == "") {
        //   this.$message.warning("请输入富信标题");
        //   return;
        // }
        // if (this.form.content == "") {
        //   this.$message.warning("请输入富信内容");
        //   return;
        // }
        if( !this.mediaId){
          this.$message.warning("请选择富信模板");
          return;
        }
        if (this.isRichSmsTest && this.form.mediaTestMobiles.length == 0) {
          this.$message.info('请选择测试手机号!');
          return
        }
      }
      if(this.form.smsType == 2){
        if( !this.cardId){
          this.$message.warning("请选择卡片短信模板");
          return;
        }
        if(this.failBackConfig.failBackType == 1 && !this.failBackConfig.content){
          this.$message.warning("请填写回落短信内容");
          return;
        }
        if(this.failBackConfig.failBackType == 2 && !this.failBackConfig.mediaTemplateId){
          this.$message.warning("请选择回落富信模板");
          return;
        }
      }

      const { content } = this.form;
      // if (!/^1[3456789]\d{9}$/.test(this.smsTest)) {
      //     this.$message.warning('请输入正确的手机号 !');
      //     return
      // }
      if (this.isRepeat(this.form.content.match(/3\.cn/g))) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      }

      if (!content || !content.trim()) {
        this.$message.warning("请输入短信内容 !");
        return;
      } else {
        // 不能含有【 或 】 的字符
        if (content.indexOf("【") !== -1 || content.indexOf("】") !== -1) {
          this.$message.warning("通道规则：短信内容请勿包含【】符号！");
          return;
        }
      }

      // 发送时间不能为空
      if ((!this.sendStart || !this.sendEnd) && !state) {
        this.$message.warning("发送时间不能为空！");
        return;
      }
      if (state) {
        if (!this.smsTest || !this.smsTest.trim()) {
          this.$message.warning("请输入测试号码 !");
          return;
        }
      }
      var domain = location.hostname;
      console.log("Domain: " , domain);
      // 敏感词检测
      if(this.form.smsType != 2 || domain != 'http://jdtestcrm.yucrm.cn' ){
        const checkResult = await this.$wordCheck({ content: this.form.content })
        if (checkResult.code != 1) {
          return this.$message.error(checkResult.message)
        }
      }
      if(this.form.smsType == 2){
        const checkFailResult = await this.$wordCheck({ content: this.failBackConfig.content })
        if (checkFailResult.code != 1) {
          return this.$message.error(checkFailResult.message)
        }
      }
      

      state ? (this.isTestSend = true) : (this.isTestSend = false);
      this.sendSmsTestState = true;
    },
    // 富信测试
    sendRichTest(){
      if(this.form.smsType == 1){
        if( !this.mediaId){
          this.$message.warning("请选择富信模板");
          return;
        }
        if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
          this.sendTestMediaConfirmShow = true;
        }else{
          this.$message.warning('请输入正确的手机号！');
          return 
        }
      }else if(this.form.smsType == 2){
        if( !this.cardId){
          this.$message.warning("请选择卡片短信模板");
          return;
        }
        if(this.failBackConfig.failBackType == 1 && !this.failBackConfig.content){
          this.$message.warning("请填写回落短信内容");
          return;
        }
        if(this.failBackConfig.failBackType == 2 && !this.failBackConfig.mediaTemplateId){
          this.$message.warning("请选择回落富信模板");
          return;
        }
        if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
          this.sendTestCardConfirmShow = true;
        }else{
          this.$message.warning('请输入正确的手机号！');
          return 
        }
      }
      
    },
    // 发送短信测试弹窗隐藏
    sendSmsTestClose() {
      this.sendSmsTestState = false;
    },
    // 短信记录
    smsDialogClose(data) {
      this.smsDialogs = data;
    },
    transferName() {
      this.smsDialogs = false;
    },
    // smsDialogClose() {
    //   this.smsDialogs = false;
    // },

    handlePreSend() {
      let params;
      let type;
      if (this.isTestSend) {
        // 测试短信发送
        type = 1;
        params = {
          mobiles: this.smsTest,
          sendType: this.sendType,
          dataFrom: 0,
        };
      } else {
        // 短信发送
        type = 2;
        params = {
          sendType: this.sendType,
          dataFrom: this.dataFrom,
        };
        if (this.sendType == 1) {
          // 按查询结果发送0
          params = Object.assign(this.searchForm, params);
        } else if (this.sendType == 2) {
          // 勾选发送

          this.dataFrom == 1
            ? (params.pins = this.checkData.map((item) => item.pin || item))
            : (params.orderIds = this.checkData.map((item) => item.orderId));

          // 自营传pins
          if (this.loginUserInfo.venderType) {
            params.orderIds = this.checkData.map((item) => item.orderId || item)
            // delete params.orderIds
          }
        } else if (this.sendType == 0) {
          console.log(this.checkData, 22323);
          params.mobile = this.checkData;
        }
      }
      this.preLoading = true;
      if(this.isTestSend){
        let postData = {
        content: this.form.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
      // preCommit(params).then((res) => {
        if (res.code == 1) {
          this.preLoading = false;
          this.$message.success(res.data);
          // this.sendObjectCount = res.data.sendObjectCount;
          // this.sendObjectId = res.data.sendObjectId;
        } else {
          this.preLoading = false;
          this.$message.warning(res.message);
        }
      });
      }else{
      //   let postData = {
      //   content: this.form.content+'拒收请回复R',
      //   // jdSmsSuffix: this.formData.jdSmsSuffix,
      //   mobile: params.mobiles,
      // }
      // 短信测试新接口
      // NewPreCommit(postData).then((res) => {
      preCommit(params).then((res) => {
        if (res.code == 1) {
          this.preLoading = false;
          this.$message.success(res.data);
          this.sendObjectCount = res.data.sendObjectCount;
          this.sendObjectId = res.data.sendObjectId;
        } else {
          this.preLoading = false;
          this.$message.warning(res.message);
        }
      });
      }
    },

    // 短信发送预提交
    handleSendConfirm() {
      // console.log(this.smsTest);

      let params;
      let type;
      if (this.isTestSend) {
        // 测试短信发送
        type = 1;
        params = {
          mobiles: this.smsTest,
          sendType: this.sendType,
          dataFrom: 0,
        };
      } else {
        this.sendSms(this.sendObjectId, type);
        return;
      }
      console.log("send",this.form.smsType)
      if(this.form.smsType == 2){
        this.sendSms(res.data.sendObjectId, type);
        return
      }
      this.preLoading = true;
      if(this.isTestSend){
              // preCommit(params).then((res) => {
      let postData = {
        content: this.form.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == 1) {
          this.preLoading = false;
          this.sendSmsTestState = false;
          this.$message.success(res.data)
          // this.sendSms(res.data.sendObjectId, type);
        } else {
          // this.sendSmsTestState = false;
          this.$message.warning(res.message);
        }
      });
      }else{
      preCommit(params).then((res) => {
      // let postData = {
      //   content: this.form.content+'拒收请回复R',
      //   // jdSmsSuffix: this.formData.jdSmsSuffix,
      //   mobile: params.mobiles,
      // }
      // 短信测试新接口
      // NewPreCommit(postData).then((res) => {
        if (res.code == 1) {
          this.preLoading = false;
          // this.sendSmsTestState = false;
          // this.$message.success(res.data)
          this.sendSms(res.data.sendObjectId, type);
        } else {
          // this.sendSmsTestState = false;
          this.$message.warning(res.message);
        }
      });
      }
    },

    // 短信发送
    sendSms(id, type) {
      let params = {};
      console.log(type);
      if (type == "1") {
        // 测试短信的发送
        params = {
          content: this.form.content + this.TTip,
          sendObjectId: id,
          smsSuffix: this.form.smsSuffix,
          blackFlag: false,
          smsType: this.form.smsType
        };
      } else {
        params = this.deepCopy(this.form);
        params.sendObjectId = id;
        if (this.form.smsType == 0 || this.isMedialSms == false) {
          params.content = params.content + this.TTip;
        } else if (this.form.smsType == 1 && this.isMedialSms) {
          params.content = params.content;
        }
        params.sendTime = this.sendStart + " " + this.sendEnd;
        params.mediaTitle = this.richMessageData.mediaTitle
        params.mediaList = this.richMessageData.mediaList
        if (this.form.smsType == 0 && this.form.content.indexOf(this.insertCoupon) != -1) {
          params.jdShortLink = this.insertCoupon;
          console.log(this.url);
          params.url = this.url;
        }
        if (this.form.smsType == 1 && this.isMedialSms) {
          params.content = this.richMessageData.content
          if (params.content.indexOf('#自定义短链#') != -1) {
            params.jdShortLink = this.richMessageData.jdShortLink
            params.url = this.richMessageData.sourceUrl;
          }
        }
      }
      params.mediaTemplateId = this.mediaTemplateId;
      this.sendSmsTestState = false;
      if(this.form.smsType == 2 ){
        params.mediaTitle = this.form.mediaTitle
        params.failBackConfig = this.failBackConfig
        if(params.failBackConfig.failBackType == 1){
          params.failBackConfig.content += this.TTip;
        }
      }
      platformSend(params).then((res) => {
        if (res.code == 1) {
          if (type == 1) {
            this.$message.success("发送成功");
          } else {
            this.successDialog = true;
          }
          // if (!this.isTestSend) this.handleClose();
        } else {
          this.$message.warning(res.message);
        }
        // this.sendSmsTestState = false;
      });
    },
    // 获取当前时间
    getNowDate() {
      var myDate = new Date(); //实例一个时间对象；
      const y = myDate.getFullYear(); //获取系统的年；
      const M = myDate.getMonth() + 1; //获取系统月份，由于月份是从0开始计算，所以要加1
      const d = myDate.getDate(); // 获取系统日，
      const h = myDate.getHours(); //获取系统时，
      const m = myDate.getMinutes(); //分
      const s = myDate.getSeconds(); //秒
      return y + String(M) + d + " " + h + ":" + m + ":" + s;
    },
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
  },
};
</script>
<style scoped lang="scss">
// ::v-deep .pickerTime .el-input--small .el-input__icon {
//     line-height: 32px;
//     padding: 0 0 0 110px !important;
// }
.notShow {
  position: relative;

  img {
    margin-left: 100px;
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    left: 197px;
    top: 328px;
    color: #999999;
    font-size: 14px;
  }

  .bottom-btn {
    width: 560px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .select {
  width: 98px;
  height: 32px;
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fff4f4;

  &:hover {
    color: #fe4d45;
    background-color: #ffe5e5;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
}
::v-deep .el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}
::v-deep .pickerTime .el-icon-date:before {
  content: "\E78E";
  padding: 0 0 0 107px !important;
}

::v-deep .pickerTime .el-icon-time:before {
  content: "\E71F";
  padding: 0 0 0 107px !important;
}

::v-deep .textareaChange .el-textarea__inner {
  border: 1px solid #dcdfe6 !important;

  &:focus {
    border: 1px solid #fe4d45 !important;
  }
}

//  ::v-deep .el-icon-close:before {
//     content: "\E6DB";
//     &:hover{
//       color: #fe4d45 !important;
//     }
// }
</style>
<style scoped lang="scss">
.btnListButtom {
        color: rgb(127, 133, 233);

        &:hover {
          color: #fe4d45;
        }
      }
.activeTip {
  color: #fe4d45;
  // padding-left: 30px;
  line-height: 25px;
  padding-bottom: 10px;
}

/* 发送确认弹窗 */
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;

    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}

.el-icon-close {
  &:hover {
    color: #fe4d45 !important;
  }
}

.sendSms {
  button {
    cursor: pointer;
  }

  /deep/ .el-drawer__wrapper {
    z-index: 2900 !important;
  }

  /deep/ .el-drawer__body {
    height: 100%;
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .head {
    flex: 0 0 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 28px;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;

    p {
      margin: 0;
    }

    .left {
      display: flex;
      align-items: center;
    }

    .close {
      color: #ccc;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
    }

    .tit {
      color: #333;
      font-size: 16px;
      margin-right: 12px;
      font-weight: 500;
    }
  }

  .topTis {
    margin: 20px 28px 0 28px;
    // display: flex;
    // align-items: baseline;
    position: relative;
    color: #333333;
    font-size: 14px;
    background: #FFFAEE;
    opacity: 1;
    padding: 12px;

    .desc {
      line-height: 20px;

      .setting-text {
        margin-bottom: 8px;

        span {
          font-size: 14px;
          color: #7f85e9;
          margin-left: 30px;
          cursor: pointer;

          &:hover {
            color: #fe4d45 !important;
          }
        }
      }

      .count {
        font-weight: bold;
        color: red;
      }

      .count1 {
        color: red;
      }
    }

    p {
      margin: 0px;
      line-height: 20px;
      // width: 700px;
    }
  }

  .main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 70%;
    box-sizing: border-box;
    padding: 0 60px 0 48px;

    p {
      margin: 0;
    }

    .textarea {
      box-sizing: border-box;
      padding: 6px 6px 10px;
      width: 100%;
      background: rgba(249, 250, 251, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 2px;

      .footInfo {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        font-size: 14px;
        color: #333;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 76px;
          height: 28px;
          outline: none;
          border: none;
          background-color: white;
          border-radius: 2px;
          font-size: 14px;
        }

        div {
          display: flex;
          align-items: center;
        }

        .select {
          // margin: 0 10px 0 8px;
          width: 76px;
          height: 28px;
          opacity: 1;
          border-radius: 3px;
          font-size: 13px;
          margin-right: 8px;
          cursor: pointer;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          background-color: #fff4f4;

          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
        }

        .question_icon {
          width: 14px;
          height: 14px;
          color: #7f85e9 !important;
          display: inline-block;
          line-height: 12px !important;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #7f85e9;
          font-size: 12px !important;
          font-weight: normal !important;
          margin-left: 8px;

          &:hover {
            color: #fe4d45 !important;
            border: 1px solid #fe4d45;
          }
        }

        .keep {
          // margin: 0 10px 0 8px;
          width: 76px;
          height: 28px;
          border-radius: 3px;
          font-size: 13px;
          /* font-family: PingFang SC; */
          font-weight: 400;
          margin-right: 8px;
          cursor: pointer;
          color: #ffffff;
          background-color: #fe4d45;

          &:hover {
            color: #fff;
            opacity: 0.9;
            background-color: #fe4d45;
          }
        }
      }

      // .ask-content {
      //   position: relative;
      //   display: inline-block;
      //   vertical-align: middle;
      //   cursor: pointer;
      //   .ask-icon {
      //     display: inline-block;
      //     vertical-align: middle;
      //     cursor: pointer;
      //     position: relative;
      //   }

      // .ask-icon-select {
      //   position: absolute;
      //   bottom: -143px;
      //   margin-left: -158px;
      //   display: none;
      //   width: 375px;
      //   // height: 80px;

      //   line-height: 20px;
      //   padding: 20px;
      //   background-color: #fff;
      //   text-align: left;
      //   box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
      //   color: #999999;
      // }
      // .ask-icon-select:before {
      //   position: absolute;
      //   content: "";
      //   width: 0;
      //   height: 0;
      //   right: 50%;
      //   margin-left: -4px;
      //   bottom: 100%;
      //   border-left: 8px solid transparent;
      //   border-top: 8px solid #fff;
      //   border-right: 8px solid transparent;
      // }
      // }
      // .ask-content:hover {
      //   .ask-icon-select {
      //     display: block;
      //   }
      // }
    }

    .footTips {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-top: 8px;
      padding-left: 12px;
      height: 28px;
      background: rgba(255, 250, 238, 1);
      border: 1px solid rgba(255, 185, 94, 1);
      border-radius: 2px;
      color: #333;
      font-size: 14px;
    }

    .tool {
      display: flex;
      align-items: center;
      height: 32px;

      p {
        box-sizing: border-box;
        padding: 0 8px;
        margin: 0 8px 0 0;
        font-size: 14px;
        border-radius: 3px;
        background-color: #f7f8fe;
        border: 1px solid #7f85e9;
        color: #7f85e9;

        &:hover {
          background: rgba(174, 179, 241, 0.16);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9 !important;
        }

        &:active {
          background: rgba(174, 179, 241, 0.24);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9;
        }
      }
    }

    .btnList {
      display: flex;
      align-items: center;
      height: 32px;

      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        cursor: pointer;
      }

      .btnListButtom {
        color: rgb(127, 133, 233);

        &:hover {
          color: #fe4d45;
        }
      }

      .btnBox {
        position: relative;
        overflow: hidden;
        height: 31px;
        margin-right: 16px;

        .btn {
          padding: 5px 12px;
          height: 31px;
          border: 1px solid rgba(254, 77, 69, 1);
          color: #fe4d45;
          cursor: pointer;
        }

        .check {
          position: absolute;
          right: -16px;
          bottom: -15px;
          width: 30px;
          height: 30px;
          background-color: #fe4d45;
          border-radius: 50%;
        }

        i {
          position: absolute;
          right: 16px;
          bottom: 15px;
          font-size: 10px;
          color: #fff;
        }
      }
    }

    .test {
      font-size: 14px;

      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        width: 98px;
        height: 32px;
        line-height: 31px;
        cursor: pointer;
        transition: all 0.2s;
      }

      .ipt {
        width: 240px;
        margin: 0 8px 0 0px;
      }

      .sendTest {
        color: #fe4d45;
        border: 1px solid rgba(254, 77, 69, 1);

        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }

      .record {
        margin: 0 0px 0 8px;
        color: #999999;
        border-radius: 3px;
        border: 1px solid #cccccc;
        background-color: #fff;

        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }

        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }

      .record1 {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
        font-size: 14px;
        border-radius: 3px;
        width: 114px;
      }
    }

    .info {
      margin-top: 12px;
      line-height: 22px;
      font-size: 14px;
      color: #999;
    }
  }

  .remarks {
    // margin-top: 20px;
    width: 400px;
    // height: 44px;
    background: #fafafa;
    opacity: 1;
    line-height: 20px;
    padding:12px 10px 10px 22px;
    font-size: 13px;
    position: relative;

    .img {
      display: inline-block;
      position: absolute;
      left: 8px;
      top: 15px;
      width: 14px;
      height: 14px;
      color: #ffffff;
    }

    span {
      display: inline-block;
      margin-left: 25px;
      line-height: 20px;
    }
  }

  .foot {
    flex: 0 0 80px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 48px;
    border-top: 1px solid #f0f0f0;
    flex-shrink: 0;

    .btn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-right: 24px;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      cursor: pointer;
      border: none;
      outline: none;
      color: #fff;
    }

    .txt {
      color: #333;
      font-size: 14px;

      .num {
        color: #fe4d45;
      }
    }
  }

  .selectBox {
    text-align: right;

    .headCnt {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }

    .keepBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }

    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }
  }

  .insertBox {
    text-align: right;

    .inser {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }

    .createUrlBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }

    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }

    .tip_box {
      text-align: left;
      line-height: 20px;
      margin-top: 10px;
      color: #fe4d45;
    }
  }

  .jumpLinkBox {
    .item {
      display: flex;
      align-items: center;
      margin-top: 20px;

      label {
        width: 80px;
        flex-shrink: 0;
        text-align: right;
        color: #333;
        font-size: 14px;
      }
    }

    .create {
      margin-top: 20px;
      text-align: right;

      .createBtn {
        border: none;
        width: 98px;
        height: 32px;
        line-height: 30px;
        background: rgba(254, 77, 69, 1);
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 3px;
        text-align: center;
        color: #fff;
      }
    }
  }

  .mobile-box {
    position: relative;
    width: 256px;
    height: 504px;

    .message-content {
      position: absolute;
      word-wrap: break-word;
      background-color: #fafafa;
      max-height: 250px;
      overflow-y: auto;
      padding: 12px 12px;
      border-radius: 6px;
      padding-right: 5px;
      width: 210px;
      font-size: 14px;
      line-height: 20px;
      left: 50%;
      margin-left: -104.665px;
      text-align: left;
      top: 25.4%;
    }
  }

  .mobile-tips {
    margin-top: 16px;
    font-size: 16px;
    text-align: center;
  }

  .sendSmsTestWrap {
    text-align: center;

    p {
      margin: 40px 0;
    }
  }

  .xiao_hug2 {
    position: absolute;
    top: 20px;
    left: 980px;
  }

  @media screen and (max-width: 1580px) {
    .xiao_hug2 {
      left: 950px;
    }
  }
}
</style>
<style lang="scss">
.sendSms {
  .el-drawer {
    min-width: 1300px;
  }

  .el-form-item__label {
    text-align: left;
  }

  .el-radio-group {
    display: flex;
    align-items: center;
  }
}

.fx_btn {

  .select {
    width: 98px;
    height: 32px;
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .keep {
    width: 98px;
    height: 32px;
    margin: 0 10px 0 8px;
    cursor: pointer;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.selectBox1 {
  text-align: right;

  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  button {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
}

.message-zindex {
  z-index: 99999 !important;
}
.media-info {
      min-width: 600px;
      margin-top: 12px;
      line-height: 22px;
      font-size: 13px;
      color: #999;
      background: #FFFAEE;
      padding: 12px;
      color: #333;
      position: relative;

      p {
        margin: 0px;
        line-height: 25px;
        padding-left: 18px;
      }

      .warning-icon {
        color: #ffb95e;
        font-size: 16px;
        position: absolute;
        left: 10px;
        top: 18px;
      }
    }
    .question_icon {
          width: 14px;
          height: 14px;
          color: #7f85e9 !important;
          display: inline-block;
          line-height: 12px !important;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #7f85e9;
          font-size: 12px !important;
          font-weight: normal !important;

          &:hover {
            color: #fe4d45 !important;
            border: 1px solid #fe4d45;
          }
        }
</style>
